import moment from "moment";
import config from "../../data/SiteConfig";

function formatDate (date) {
        const d = moment(date, config.dateFromFormat);
        return d.format('dddd, MMMM Do YYYY');
}

export {formatDate as default}
